import FAQsContent from './FAQContent';

export default FAQsContent;
